import PageSection from '../../components/common/PageSection';
import { pageData } from '../../data/pageData';

function SettingsPage() {
  return <PageSection {...pageData.settings} />;
}

export default SettingsPage;
